import { useState } from "react";
import { Link, useParams } from "react-router-dom";
import ActionBar from "../../components/actionBar/ActionBar";
import DevicesTable from "../../components/Devices/DevicesTable";
import { useAdminDevices } from "../../hooks/useAdminDeviceList";
import strings from "../../i18n/i18nStrings";
import { TAccount } from "../../types/Accounts";

const AdminDevicePage = () => {
  const { account_id } = useParams<{ account_id: string }>();
  const { devices, filters, updateFilter } = useAdminDevices(account_id!);

  return (
    <>
      <div className="p-0">
        <nav className="text-sm hidden md:block m-4">
          <Link
            to="/admin"
            className="font-semibold underline text-blue-700 hover:text-blue-800"
          >
            Admin List
          </Link>{" "}
          &gt;{" "}
          <span className="px-0 pr-3 font-semibold text-grey-900">
            Account Detail
          </span>
        </nav>
        <div className="bg-white shadow rounded-lg overflow-hidden">
          <DevicesTable
            showAddDeviceButton={false}
            devices={devices}
            updateFilter={updateFilter}
            filters={filters}
          />
        </div>
        {/* <ActionBar> */}
        {/* <button
            onClick={() => setIsAddAccountModalOpen(true)}
            className={`ml-auto px-4 py-3 border border-transparent rounded-md shadow-sm text-xs font-bold uppercase tracking-wider text-white ${"bg-blue-700 hover:bg-blue-800"}`}
          >
            {strings.admin.addAccount}
          </button> */}
        {/* </ActionBar> */}
      </div>
    </>
  );
};

export default AdminDevicePage;
